'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = exports.Header = undefined;

var _Header2 = require('./Header');

var _Header3 = _interopRequireDefault(_Header2);

var _Logo2 = require('./Logo/Logo');

var _Logo3 = _interopRequireDefault(_Logo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Header = _Header3.default;
exports.Logo = _Logo3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/index.js
// module id = 1679
// module chunks = 0